module.exports = __webpack_public_path__ + "img/IFEA-Treuhand-GmbH-LOGO-STACKED.49f4c9dd.png";